import { trackEvent } from "#app/utils/gtags.client.ts";
import { preorderAction } from "#app/utils/wear/messages.ts";
import { type PreorderState } from "#app/utils/wear/state.ts";
import { Button } from "../ui/button.tsx";

type Props = {
  state: PreorderState;
  word?: { slug: string; printed: string };
  paymentUrl?: string | null;
};

export function PreorderButton({ state, word, paymentUrl }: Props) {
  const action = preorderAction(state, !!word);
  return action.enabled && paymentUrl ? (
    <Button asChild size="lg" className="w-full font-sans">
      <a
        href={paymentUrl}
        onClick={() => trackEvent("wear_preorder_click", { word: word!.slug })}
      >
        {action.label}: {word!.printed}
      </a>
    </Button>
  ) : (
    <Button size="lg" className="w-full font-sans" disabled>
      {action.label}
    </Button>
  );
}

export function PreorderPanel(props: Props) {
  const action = preorderAction(props.state, !!props.word);
  return (
    <section
      aria-labelledby="preorder-heading"
      className="space-y-4 rounded-lg border border-border bg-card p-6"
    >
      <h2 id="preorder-heading" className="text-h5">
        £55 · free UK delivery · limited to 47
      </h2>
      <PreorderButton {...props} />
      <p
        aria-live="polite"
        className="font-sans text-body-xs text-muted-foreground"
      >
        {action.reason && action.reason !== action.label ? action.reason : ""}
      </p>
      <p className="text-body-sm">
        We check every word before it goes to print. If we can't print yours,
        we'll help you pick another or refund you in full.
      </p>
      <ul className="list-disc space-y-1 pl-5 text-body-sm text-muted-foreground">
        <li>Pre-orders close on Sunday 10 January 2027.</li>
        <li>
          If fewer than 20 are ordered by then, everyone gets a full refund.
        </li>
        <li>Delivered free in the UK only, before 18 April 2027.</li>
        <li>You can cancel within 14 days of ordering for a full refund.</li>
        <li>Seller details will be added before pre-orders open.</li>
      </ul>
    </section>
  );
}
